import { usePageMeta } from '@/hooks/usePageMeta';
import { useLocation } from 'react-router-dom';
import GalleryHeader from './components/GalleryHeader';
import GalleryGrid from './components/GalleryGrid';

export default function Gallery() {
  const location = useLocation();

  usePageMeta(
    'Gallery | Keaton Brown — Headshots & Production Photography',
    'Browse Keaton Brown\'s gallery featuring portrait headshots and production photography from Opera North, Nashville Opera, Seagle Festival, and more. Based in Houston, Texas.'
  );

  return (
    <main>
      <GalleryHeader />
      <GalleryGrid />
    </main>
  );
}